import type { UsageTrackData } from "../../../backend/usage-track/UsageTrackApi";

export interface UsageTrackState {
	usage: Array<UsageTrackData>;
}

export const initialUsageTrackState: UsageTrackState = {
	usage: [],
};
